/**
 * Environment variables configuration for Verity application
 * These variables are replaced at deployment time using Katal webpack plugin
 */

// Environment variables object
const ENVIRONMENT_VARIABLES = Object.freeze({
  env: {
    // Base configuration
    Region: 'us-west-2',
    Stage: 'alpha',
    BuildTime: '9/7/2026, 7:39:53 pm',
    AwsAccountId: '121838513191',
    VerityUser: 'hbhardwj',

    // CloudFront configuration
    CloudFrontProtocol: 'https',
    CloudFrontDomain: 'da3ytecw750l1.cloudfront.net',
    ApplicationDomain: 'hbhardwj.alpha.verity.device.finance.amazon.dev',

    // Authentication configuration
    CognitoUserPoolId: 'us-west-2_03Fd9D4Sg',
    CognitoUserPoolWebClientId: '3l0areig9h96umcf0lg5t534sc',
    CognitoIdentityPoolId: 'us-west-2:92e8157d-1c71-429c-84fb-56521045f440',
    CognitoDomain: 'verity-application-alpha.auth.us-west-2.amazoncognito.com',
    AuthRoleARN: 'arn:aws:iam::121838513191:role/DasFintechVerityCognito-S-CognitoAuthenticatedRole5-k7OuZMcr0Rit',
    UnAuthRoleARN: 'arn:aws:iam::121838513191:role/DasFintechVerityCognito-S-CognitoUnauthenticatedRol-WYaUNuJ1JaWY',

    // Monitoring and logging
    RumAppMonitorId: 'e8275eb1-7d13-49ac-9093-43fb8b17d474',
    LoggerUrl: 'https://logger-alpha.verity.device.finance.amazon.dev/v1/log',
    MetricsUrl: 'https://monitoring-alpha.verity.device.finance.amazon.dev/v1/monitoring',

    // Dashboard registry
    DashboardsTableName: 'verity-dashboards-alpha',
  },
});

export default ENVIRONMENT_VARIABLES;
